import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'highlight',
    standalone: true,
})
export class HighlightPipe implements PipeTransform {
    transform(title: any, query: any) {
        if (!query || !title) {
            return title;
        }

        const lowerTitle = title.toLowerCase();
        const lowerQuery = query.toLowerCase();
        const queryLen = lowerQuery.length;
        const len = lowerTitle.length;

        let result = '';

        for (let i = 0; i < len; i++) {
            let highlight = true;
            let j;

            if (i + queryLen <= len) {
                for (j = 0; j < queryLen; j++) {
                    const ct = lowerTitle[i + j];

                    const qt = lowerQuery[j];

                    if (ct !== qt) {
                        highlight = false;
                        break;
                    }
                }
            } else {
                j = len - i - 1;
                highlight = false;
            }

            if (highlight) {
                result += '<pre>';
                j--;
            }

            for (let k = 0; k <= j; k++) {
                result += title[i + k];
            }

            i += j;

            if (highlight) {
                result += '</pre>';
            }
        }

        return result;
    }
}
